import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight } from 'lucide-react';
import './About.css';

const TEAM = [
  { name: 'Sandeep Saraswat', role: 'Founder & Managing Director', desc: '20+ years of expertise in Indian real estate. Visionary leader behind Smart Property Solutions since 2013, with deep market knowledge across Delhi NCR and Gujarat.' },
  { name: 'Neera Saraswat', role: 'Co-Founder & Director', desc: 'Co-founder with a strong background in client relations and investment advisory. Instrumental in building SPS into a trusted name across Delhi NCR, Dholera SIR, and Ahmedabad.' },
  { name: 'Ravi Gupta', role: 'Chief Architect', desc: 'M.Arch from SPA Delhi. Led design of 15+ residential and commercial developments across India.' },
  { name: 'Meena Nair', role: 'Head - NRI Relations', desc: 'Specialist in NRI property investments with clients across the US, UK, UAE and Canada.' },
];

const About = () => (
  <div className="about-page">
    <section className="page-hero">
      <div className="container">
        <span className="section-label">Who We Are</span>
        <h1 className="section-title light">About Smart Property Solutions</h1>
        <p className="page-hero__sub">Trusted real estate partners across Delhi NCR, Dholera SIR, and Ahmedabad since 2013</p>
      </div>
    </section>

    <section className="about-story">
      <div className="container">
        <div className="about-story__grid">
          <div className="about-story__images">
            <img src="https://images.unsplash.com/photo-1560520653-9e0e4c89eb11?w=700&q=80" alt="Smart Property Solutions office" />
          </div>
          <div className="about-story__text">
            <span className="section-label">About Us</span>
            <h2 className="section-title">Trusted Real Estate Partners Since 2013</h2>
            <div className="gold-divider" />
            <p>Smart Property Solutions is a trusted real estate development and brokerage company specialising in residential and commercial properties across India's fastest growing markets.</p>
            <p style={{marginTop:'16px'}}>With an experienced in-house team of architects, planners, and industry professionals, we develop modern spaces and connect investors to high-growth opportunities in Delhi NCR, Dholera SIR, and Ahmedabad.</p>
            <ul className="about-story__points" style={{marginTop:'20px'}}>
              {['RERA Registered and Compliant','In-house Architecture Team','NRI Investment Specialists','Channel Partner Network'].map(p => (
                <li key={p}><CheckCircle size={16}/> {p}</li>
              ))}
            </ul>
            <div className="about-cta-btns">
              <Link to="/contact" className="btn-outline-dark" style={{display:'inline-flex',alignItems:'center',gap:'8px'}}>
                Contact Us <ArrowRight size={15}/>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section style={{background:'var(--navy)',padding:'100px 0'}} className="about-section-padding-nav">
      <div className="container">
        <div style={{textAlign:'center',marginBottom:'48px'}}>
          <span className="section-label">Our Values</span>
          <h2 className="section-title light">The Principles We Build On</h2>
        </div>
        <div className="values-grid">
          {[
            {icon:'🔍', title:'Transparency', desc:'Every transaction is fully disclosed with no hidden charges and no surprises.'},
            {icon:'🏆', title:'Excellence', desc:'We hold ourselves to the highest standards of design, construction, and service.'},
            {icon:'🤝', title:'Integrity', desc:'We act in our clients best interests, every single time.'},
            {icon:'💡', title:'Innovation', desc:'From smart city investments to technology-enabled property search, we lead the way.'},
          ].map((v,i) => (
            <div className="value-card" key={i}>
              <span className="value-icon">{v.icon}</span>
              <h4>{v.title}</h4>
              <p>{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="about-section-padding">
      <div className="container">
        <div style={{textAlign:'center',marginBottom:'48px'}}>
          <span className="section-label">Our Team</span>
          <h2 className="section-title">Meet the Experts</h2>
        </div>
        <div className="team-grid">
          {TEAM.map((m,i) => (
            <div className="team-card" key={i}>
              <div className="team-card__avatar">{m.name.split(' ').map(n=>n[0]).join('')}</div>
              <h4>{m.name}</h4>
              <span>{m.role}</span>
              <p>{m.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section style={{background:'var(--off-white)',padding:'80px 0'}}>
      <div className="container" style={{textAlign:'center'}}>
        <h2 className="section-title">Ready to Find Your Dream Property?</h2>
        <p style={{color:'var(--text-2)',margin:'16px auto 0',maxWidth:'500px',lineHeight:'1.7'}}>Let our experts guide you to the right investment or home across Delhi NCR, Dholera SIR, and Ahmedabad.</p>
        <div className="about-cta-btns" style={{justifyContent:'center',marginTop:'32px'}}>
          <Link to="/properties" className="btn-primary">Browse Properties <ArrowRight size={16}/></Link>
          <Link to="/contact" className="btn-outline-dark">Contact Us</Link>
        </div>
      </div>
    </section>
  </div>
);

export default About;
